<template>
  <div id="Sample-results-grid-view">
    <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        :context="context"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="sampleList"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true" 
        :pagination="false"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
    </ag-grid-vue>
  </div>
</template>
<script>
import Vue from "vue";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";

import CellSampleActions from './CellSampleActions.vue'

export default {
  name:"SampleListGrid",  
  /* eslint-disable vue/no-unused-components */
  components: {
    AgGridVue,
    CellSampleActions
  },
  props: {
    selectedMuck: {
      type: Object
    }
  },
  data() {
    return {
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: true
      },
      gridApi: null,
      gridOptions: {
        getRowNodeId: (data) => {
          return data.sampleId;
        }
      },
      context: { componentParent: this },
      columnDefs: [
        {
          headerName: 'Actions',
          field: 'sampleCount',
          width: 120,
          filter: false,
          cellRendererFramework: Vue.extend(CellSampleActions)
        },
        {
          headerName: this.$t('GradeControl.ExtractionDate'),
          field: "extractionDate",
          width: 185,
          filter: 'agDateColumnFilter',
          valueFormatter: this.formatDateTime
        },
        {
          headerName: this.$t('GradeControl.Shift'),
          field: "muckShift",
          width: 120,
          valueGetter: (params) => {
            return this.$t("Shift." + params.data.muckShift);
          }
        },
        {
          headerName: this.$t('GradeControl.Forecast.Tonnage'),
          field: "relatedTonnage",
          width: 150,
          filter: 'agNumberColumnFilter',
          valueFormatter: this.formatTonnage
        },
        {
          headerName: this.$t('GradeControl.Timesheet.RoundNumber'),
          field: "roundNumber",
          width: 150,
          filter: 'agNumberColumnFilter'
        },
        {
          headerName: this.$t('GradeControl.Sample.Title'),
          field: "code",
          width: 165
        },
        {
          headerName: this.$t('Gold'),
          field: "goldGrade",
          width: 125,
          filter: 'agNumberColumnFilter',
          valueFormatter: this.formatGrade
        }
      ],
      components: {
        CellSampleActions
      }
    }
  },
  computed: {
    sampleList() {
      return this.$store.state.gradeControl.samples;
    }
  },
  methods: {
    formatDateTime(params) {
      return this.$options.filters.toDate(params.value);
    },
    getSamplesList(locationForecastId) {
      if (locationForecastId) {
        return this.$store.dispatch("gradeControl/fetchLocationForecastSamples", locationForecastId);
      }
    },
    formatTonnage(params) {
      return this.$options.filters.toInteger(params.value);
    },
    formatGrade(params) {
      return this.$options.filters.toFriendlyGrade(params.value);
    },
    updateSample(sample) {
      if (sample) {
        this.$emit("onUpdateSample", sample);
      }
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  }
};
</script>
<style lang="scss">
#Sample-results-grid-view {
   .ag-header-group-text {
     text-align: center;
     border: 1px;
     
   }
   .ag-grid-table {
     height: 735px;
   }
   .ag-header-group-cell-label {
     align-content: center;
   }
}
  </style>
